import SwiperCarouselBase from "../utils/swiper_carousel_base"

const TWO_COLUMN_MIN_WIDTH = 640
const THREE_COLUMN_MIN_WIDTH = 900
const SLIDE_SPEED_MS = 1000

export default class extends SwiperCarouselBase {
  get paginationBulletMessage() {
    return "Go to article group {{index}}"
  }

  get layoutOptions() {
    return {
      slidesPerView: 1,
      spaceBetween: this.spaceBetweenValue,
      speed: SLIDE_SPEED_MS,
      breakpoints: {
        [TWO_COLUMN_MIN_WIDTH]: { slidesPerView: 2 },
        [THREE_COLUMN_MIN_WIDTH]: { slidesPerView: 3 }
      }
    }
  }

  get carouselState() {
    let slidesPerView = 1
    if (window.innerWidth >= THREE_COLUMN_MIN_WIDTH) {
      slidesPerView = 3
    } else if (window.innerWidth >= TWO_COLUMN_MIN_WIDTH) {
      slidesPerView = 2
    }
    const enabled = this.slideCount > slidesPerView
    return { slideEnabled: enabled, loopEnabled: enabled }
  }
}
